import { WorkspaceEmailSuppressionListRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list')(
  {
    component: WorkspaceEmailSuppressionListRoute,
  },
);
